<template>
  <div>
    <v-fade-transition>
      <div
        v-if="isEmpty"
        class="empty-state-container"
      >
        <div class="pa-5">
          <img
            src="@/assets/illustrations.png"
            srcset="@/assets/illustrations@2x.png 2x, @/assets/illustrations@3x.png 3x"
            class="illustrations"
          >
          <div class="header">
            Welcome to iisy, {{ $store.state.user.me.name }}!
          </div>

          <div
            v-if="!isProductAndCountrySet"
            class="text"
          >
            Please select a product and a country on the left.
          </div>
          <div
            v-else
            class="text"
          >
            So far, you have no slides in your libary. It’s time for you to create your first slide. You can also get some slides of the EU Master library. It’s iisy.
          </div>
          <p class="mt-3 justify-center  button-area">
            <div class="buttons">
              <core-button
              v-if="isProductAndCountrySet"
              label="Add Slide"
              :icon="icons.add"
              @click="$router.push({ query: { ...$route.query, dialog: 1, form: 'add_slide' } })"/>
            <!-- IF MASTER HIDE AND MAKE COMMIT AUTO TO MASTER OF BRAND -->
            <core-button
              v-if="isProductAndCountrySet"
              class="mt-3"
              label="Go to Master Library"
              color="#ed736d"
              @click="$store.commit('product/setCurrent', { product: $store.state.product.selected.product, country: 'EU' })"
            />
            </div>
          </p>
        </div>
      </div>
      <div v-else>
        <slot />
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import CoreButtonVue from "../core/buttons/CoreButton.vue";
import icons from "../../mixins/icons";
import { SessionService } from "../../services/SessionService";
export default {
  name: "EmptyState",
  components: {
    coreButton: CoreButtonVue
  },
  mixins: [icons],
  props: {
    isEmpty: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isProductAndCountrySet() {
      return (
        this.$store.state.product.selected.product &&
        this.$store.state.product.selected.country
      );
    }
  }
};
</script>

<style scoped>
.button-area {
  /* width: 130px; */
  min-width: 130px;
  max-width: 170px;
  margin: 0 auto;
}
.buttons {
  max-width: 200px;
  margin: 0px auto
}
.text {
  width: 400px;
  margin: 0 auto;
}
.header {
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}
.illustrations {
  mix-blend-mode: multiply;
}
.empty-state-container {
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
